module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-1-468.fb00073a10754dc4.jpg"+" 468w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-1-468.fb00073a10754dc4.jpg",width: 468,height: 312}],
        src: "https://static.sniffspot.com/packs/img/bp-1-468.fb00073a10754dc4.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-1-468.fb00073a10754dc4.jpg"},
        
        width: 468,
        height: 312
      }